import { VersionSwitcherDefinition } from '@fluentui/public-docsite-setup';

export interface ILoadingComponentProps {
  title?: string;
  shimmer?: boolean;
  versionSwitcherDefinition?: VersionSwitcherDefinition;
}
